// extracted by mini-css-extract-plugin
export default {"main-container":"ERPCallback_main-container__fHXzn"};